"use client";

import { useState } from "react";
import useCareer from "../_hooks/useCareer";
import CareerSkeleton from "../skeleton/CareerSkeleton";
import Link from "next/link";
import { slug } from "@/lib/helpers";

export default function CareerSection({ categories }) {
    const [activeCategory, setActiveCategory] = useState(0);
    const { jobs, loading } = useCareer(activeCategory);

    return (
        <section className="career-section section-bg pt-60 pb-100">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="career-tag">
                            <button
                                onClick={() => setActiveCategory(0)}
                                className={`career-tag__item ${
                                    activeCategory === 0 ? "active" : ""
                                }`}
                            >
                                All
                            </button>
                            {categories.map((cat) => (
                                <button
                                    key={cat.id}
                                    onClick={() => setActiveCategory(cat.id)}
                                    className={`career-tag__item ${
                                        activeCategory === cat.id
                                            ? "active"
                                            : ""
                                    }`}
                                >
                                    {cat.name}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="col-12">
                        {loading ? (
                            <CareerSkeleton />
                        ) : jobs.length === 0 ? (
                            <div
                                className="career-item d-flex flex-column align-items-center justify-content-center text-center"
                                style={{ minHeight: "200px" }}
                            >
                                <div className="career-item__info">
                                    <div className="mb-3">
                                        <i className="fas fa-briefcase fa-2x"></i>
                                    </div>
                                    <h6 className="career-item__title mb-0">
                                        No jobs found in this category.
                                    </h6>
                                </div>
                            </div>
                        ) : (
                            jobs.map((job) => (
                                <div className="career-item" key={job.id}>
                                    <div className="career-item__info">
                                        <h6 className="career-item__title">
                                            <a
                                                href={`careers/${job.id}/${slug(
                                                    job.title
                                                )}`}
                                                className="career-item__title-link"
                                            >
                                                {job.title}
                                            </a>
                                        </h6>
                                        <p className="career-item__duration">
                                            {job.type}
                                        </p>
                                    </div>
                                    <p className="career-item__type">
                                        {job.location}
                                    </p>
                                    <Link
                                        href={`careers/${job.id}/${slug(
                                            job.title
                                        )}`}
                                        className="career-item__link"
                                    >
                                        Click to view
                                    </Link>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
}
